module.exports = __webpack_public_path__ + "img/special_events.9ef194ac.jpg";